<template>
  <v-container fluid grid-list-sm>
    <v-layout row wrap>
      <v-flex>
        <h3 class="headline grey--text text--darken-1 pt-0 pb-0">{{ title }}</h3>
        <div v-if="items.length">
          <h4 class="title grey--text text--darken-1 pt-3 pb-3">HTML Sitemap ({{ items.length }} items)</h4>
          <ol class="inside-list">
            <li v-for="(item, index) in items" v-html="item" />
          </ol>
        </div>
        <div v-if="sitemap">
          <h4 class="title grey--text text--darken-1 pt-3 pb-3">XML Sitemap</h4>
          <p>Copy the below and save to <code>{{ $store.state.domain }}/sitemap.xml</code> file on your server.
            Then register with <a href="https://www.google.com/webmasters/tools/" target="_blank">
              Google Search Console</a>.</p>
          <code v-if="sitemap">
            <xmp v-html="sitemap" />
          </code>
        </div>
      </v-flex>
    </v-layout>
  </v-container>
</template>
<script>
  import Mixins from '../helpers/Mixins'

  export default {
    name: 'SiteMapGenerator',
    mixins: [
      Mixins
    ],
    data () {
      return {
        items: [],
        sitemap: '',
        title: this.$store.getters.getLangKey('sitemapGeneratorPageTitle')
      }
    },
    mounted () {
      const store = this.$store
      const state = store.state
      const ajax = state.events.ajax
      const bootstrap = state.bootstrapData
      const domain = state.domain
      const apiProxyUrl = state.apiProxyUrl
      const unlimitedPostsLimit = state.unlimitedPostsLimit
      const sitemap = []
      const items = []
      this.$root.$emit(ajax, true)
      this.$http(`${apiProxyUrl}?resource=get_posts&count=${unlimitedPostsLimit}`).then(response => {
        response = response.data
        response.posts.forEach(post => {
          items.push(`${domain}/${this.removeDomainFromUrl(post.url)}`)
        })
        bootstrap.tags.forEach(tag => {
          items.push(`${domain}/tag/${tag.slug}`)
        })
        bootstrap.categories.forEach(category => {
          items.push(`${domain}/category/${category.slug}`)
        })
        this.$http(`${apiProxyUrl}?resource=get_author_posts&slug=${state.author}&count=${unlimitedPostsLimit}&post_type=page`).then(response => {
          response = response.data
          response.posts.forEach(page => {
            items.push(`${domain}${state.pageTopSlug}/${page.slug}`)
          })
          items.forEach(item => {
            sitemap.push(`\n\t<url>
\t\t<loc>${item}</loc>
\t\t<changefreq>daily</changefreq>
\t\t<priority>1.0</priority>
\t</url>`)
          })
          sitemap.unshift(`<urlset xmlns="http://www.sitemaps.org/schemas/sitemap/0.9" xmlns:xsi="http://www.w3.org/2001/XMLSchema-instance" xsi:schemaLocation="http://www.sitemaps.org/schemas/sitemap/0.9 http://www.sitemaps.org/schemas/sitemap/0.9/sitemap.xsd">`)
          sitemap.push(`\n</urlset>`)
          this.sitemap = sitemap.join('')
          this.items = items
          this.setTitle(this.title)
          this.$root.$emit(ajax, false)
        })
      })
    }
  }
</script>
<style>
xmp
{
  padding: 1em;
  tab-size: 2;
  white-space: pre-wrap;
}
</style>



// WEBPACK FOOTER //
// src/pages/SiteMapGenerator.vue